import IScalarForm from "../interface/IScalarForm"
import Scalar from "./Scalar"

/* Protopia Ecosystem component */ 
const EditingArray = (props: IScalarForm): JSX.Element => {
    return <Scalar
        {...props}
        enabledForm={<EditingArrayEnabled {...props} />}
        desabledForm={<EditingArrayDisabled {...props} />}
    />
}
export default EditingArray

const EditingArrayDisabled = (props: IScalarForm): JSX.Element => {
    return <>EditingArrayDisabled</>
}
const EditingArrayEnabled = (props: IScalarForm): JSX.Element => {
    const onChange = (value: number) => { 
        if( props.onChange )
        {
            props.onChange( value,  props.field, "" )
        }   
    }
    return <div className=" d-flex justify-content-center my-2 form-control p-0 input dark" >
        EditingArrayEnabled
    </div>
}